import { Link } from "react-router-dom";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import StoryGrid from "../StoryGrid";
import { useStories } from "../../hooks/CmsHooks";
import { Suspense } from "react";
import { Spinner } from "reactstrap";

const StoryGridMenuContent = () => {
  const t = useBjelinTranslations();
  const stories = useStories(1);
  return stories.length > 0 ? (
    <div>
      <h3>
        <Link to="/stories">
          <span className="title black-on-hover">{t("stories.heading")}</span>
          <span className="more">
            {t("more")}{" "}
            <Icon name="chevron-right" type="fal" className="ms-1" />
          </span>
        </Link>
      </h3>
      <StoryGrid limit={2} />
    </div>
  ) : null;
};

const StoryGridMenu = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <StoryGridMenuContent />
    </Suspense>
  );
};

export default StoryGridMenu;
